const responseCode = {
  success: 200,
  authFailed: 500,
}

export default responseCode
